import { makeStyles } from "@fluentui/react-components";
import designTokens from "theme/customTheme";

export const useStyles = makeStyles({
  userMenuWrapper: {
    marginTop: "auto",
    padding: `0 ${designTokens.spacing[3]}`,
    width: "fit-content",
  },
  userMenuPanel: {
    backgroundColor: designTokens.neutral[50],
    borderRadius: designTokens.borderRadius.lg,
    boxShadow: designTokens.shadow.lg,
    overflow: "hidden",
    marginBottom: designTokens.spacing[2],
    width: "100%",
  },
  userMenuHeader: {
    display: "flex",
    alignItems: "center",
    gap: designTokens.spacing[3],
    padding: `${designTokens.spacing[3]} ${designTokens.spacing[3]}`,
    overflow: "hidden",
  },
  userMenuHeaderName: {
    fontSize: designTokens.fontSize.sm,
    fontWeight: designTokens.fontWeight.semibold,
    color: designTokens.neutral[900],
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  userMenuHeaderInfo: {
    minWidth: 0,
    overflow: "hidden",
  },
  logoutIcon: {
    color: designTokens.semantic.error,
  },
  userMenuItem: {
    width: "100%",
    justifyContent: "flex-start",
    whiteSpace: "nowrap",
    padding: `${designTokens.spacing[3]} ${designTokens.spacing[3]} ${designTokens.spacing[3]} ${designTokens.spacing[5]}`,
    fontSize: designTokens.fontSize.sm,
    fontWeight: designTokens.fontWeight.normal,
    color: designTokens.neutral[700],
    backgroundColor: "transparent",
    border: "none",
    borderRadius: 0,
    cursor: "pointer",
    ":hover": {
      backgroundColor: designTokens.neutral[100],
      color: designTokens.neutral[700],
      border: "none",
      cursor: "pointer",
    },
    ":focus-visible": {
      outline: `2px solid ${designTokens.accent[500]}`,
      outlineOffset: "-2px",
    },
  },
  userMenuItemIcon: {
    color: designTokens.neutral[500],
    flexShrink: 0,
  },
  userMenuLogout: {
    width: "100%",
    justifyContent: "flex-start",
    padding: `${designTokens.spacing[3]} ${designTokens.spacing[3]} ${designTokens.spacing[3]} ${designTokens.spacing[5]}`,
    fontSize: designTokens.fontSize.sm,
    fontWeight: designTokens.fontWeight.normal,
    color: designTokens.semantic.error,
    backgroundColor: "transparent",
    border: "none",
    borderRadius: 0,
    cursor: "pointer",
    ":hover": {
      backgroundColor: designTokens.neutral[100],
      color: designTokens.semantic.error,
      border: "none",
      cursor: "pointer",
    },
    ":focus-visible": {
      outline: `2px solid ${designTokens.accent[500]}`,
      outlineOffset: "-2px",
    },
  },
  userMenuDivider: {
    margin: `${designTokens.spacing[1]} 0`,
  },
});
